import React from 'react';

const MinusIcon = () => {
  return (
    <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 .615a.617.617 0 0 1-.615.616H.615A.615.615 0 1 1 .615 0h14.77c.338 0 .615.277.615.615z"
        fill="currentColor"
        strokeWidth="0"
      />
    </svg>
  );
};

export default MinusIcon;
